const ImageComponent = ({file}) => {
    return (
        <img src={file.file} alt='Model'/>
    )
}
export default ImageComponent;